import http from "@/services/http";

/**
 * Lista os recordatórios alimentares de um paciente
 * (tabela patient_dietary_recalls), mais recente primeiro.
 *
 * @param {number|string} patientId
 * @returns {Promise<object[]>}
 */
export async function getDietaryRecallByPatient(patientId) {
  const { data } = await http.get(
    `/api/patient-dietary-recalls/get-by-patient/${patientId}`,
  );
  return data?.status === "success" ? data.data || [] : [];
}
